module.exports = __webpack_public_path__ + "img/none.cdcddd95.png";